import React, { memo } from 'react';

interface IPhoneHangupIconProps {
  size?: number;
  className?: string;
}

const PhoneHangupIcon: React.FC<IPhoneHangupIconProps> = memo(
  ({ size = 16, className = '' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 16"
      className={className}
      fill="currentColor">
      <path
        d="M17.7226 12.2992C18.3148 12.5423 18.991 12.308 19.307 11.7578L19.3954 11.6031C20.434 9.78662 20.2705 7.18344 18.2308 5.85533C13.5438 2.80798 7.45789 2.80798 2.77085 5.85533C0.726753 7.18344 0.567646 9.78662 1.60627 11.6031L1.69466 11.7578C2.01066 12.3125 2.68908 12.5445 3.2769 12.3014L6.32204 11.0462C6.83914 10.8341 7.15515 10.3059 7.0999 9.74684L6.90986 7.85081C9.2346 7.06853 11.7759 7.10831 14.0785 7.97456L13.8973 9.74684C13.8399 10.3037 14.1581 10.8297 14.6752 11.0462L17.7226 12.2992Z"
        fill="#EB5757"
      />
    </svg>
  ),
);

export { PhoneHangupIcon };
